export const SONIC_REDIRECT_URL = 'https://sonicdrivein.smart.link/27lmlmo47';
